/** saves Available Products in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsproducts
*/
export const SAVE_AVAILABLE_PRODUCTS = (state, payload) => {
    state.availableProducts = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_PRODUCTS_LIST_FEATURE_STATE = (state, payload) => {
    state.availableProducts = []
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_PRODUCT_INTEREST_RATES = (state, payload) => {
    state.productInterestRates = payload
}

/** saves Product Plafond
@payload { Object } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsproducts%7Bid%7Dplafond_
*/
export const SAVE_PRODUCT_PLAFOND = (state, payload) => {
    state.productPlafond = payload
}

/** Clears all state for this feature to make sure we have a clean state when entering feature
* this also makes our app lighter and faster
*/
export const CLEAR_CREATE_DP_STATES = (state, payload) => {
    state.accountsBalances = []
    state.productInterestRates = []
    state.productPlafond = {}
}
